module.exports = "\r\n\r\n\r\n<div>Stripe checkout completed!</div>"